// Copyright (c) 2020 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap, tap, withLatestFrom } from "rxjs/operators"
import * as UserContextSlice from "../slice"
import { setTimeZone } from "../../timeline/actions"
import { generateTimeZoneInfo } from "../../../app/timeZone"
import { Settings } from "luxon"
import { t } from "@lingui/macro"
import { RootState } from "../../../app/store"
import { showSnackBar } from "../../snackbar/actions"

// When a user context is loaded, this epic automatically generates a suitable timezone information.
// Moreover, it sets the default Luxon timezone according to the given one.
export const setUpTimeZone = () =>
  (action$: Observable<Action>, state$: Observable<RootState>): Observable<Action> =>
    action$.pipe(
      filter(UserContextSlice.setUserDetails.match),
      withLatestFrom(state$),
      mergeMap(([action, state]) => of(action.payload).pipe(
        // Generate the timezone information from the user context
        map(userDetails =>
          generateTimeZoneInfo(userDetails.user.getTimezone(), state.timeline.activeDate)
        ),
        // Sets the default luxon timezone
        tap(timeZone => Settings.defaultZone = timeZone.name),
        // Update the timezone information in the slice
        map(setTimeZone),
        catchError(_ => of(showSnackBar({
          message: t({
            id: "msg_configure_timezone_failed",
            message: "Failed to load your current time zone. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com."
          }),
          messageType: "ERROR",
        }))),
      )),
    )

export default setUpTimeZone()
